import fp from 'lodash/fp';
import { all, takeLatest } from 'redux-saga/effects';
import { configurations } from './configurations';

export { getContentById } from './configurations/getById';
export { loadMoreContent } from './configurations/loadMore';
export { rateContent } from './configurations/rateContent';

function* contentSagas() {
  yield all(
    fp.flow(
      fp.filter(
        ({ sagas }) => sagas
      ),
      fp.map(
        ({ name, sagas, action }) => {
          return takeLatest(action.content[name]().type, sagas)
        }
      )
    )(configurations)
  );
}

export default contentSagas;



// WEBPACK FOOTER //
// ./src/state/modules/content/sagas.js